/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import braintree from 'braintree-web';

const usePayPalAvailability = (clientToken) => {
  const [isPayPalEnabled, setIsPayPalEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!clientToken) {
      setIsLoading(false);
      setIsPayPalEnabled(false);
      return;
    }

    let isMounted = true;
    setIsLoading(true);

    braintree.client.create({
      authorization: clientToken
    }).then(clientInstance => {
      if (!isMounted) return;
      
      const config = clientInstance.getConfiguration();
      if (config.gatewayConfiguration && config.gatewayConfiguration.paypalEnabled === true) {
        setIsPayPalEnabled(true);
      } else {
        setIsPayPalEnabled(false);
      }
      setIsLoading(false);
    }).catch(err => {
      if (!isMounted) return;
      // If client creation fails (e.g. invalid token), PayPal is not available.
      // We log to warn but swallow the error to prevent crash
      // console.warn('PayPal availability check failed:', err);
      setIsPayPalEnabled(false);
      setIsLoading(false);
    });

    return () => { isMounted = false; };
  }, [clientToken]);

  return { isPayPalEnabled, isLoading };
};

export default usePayPalAvailability;
